module.exports = __webpack_public_path__ + "static/img/name5.bd087e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/name5.png
// module id = jfYO
// module chunks = 1